import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { StatusEnum } from "../../../../../../commons/enums/status-enum";
import { manageFootballTeamService } from "../../../../../../commons";
import { IHostedCompetitionDTO } from "../../../../../../api-services/football/admin/manage-football-team-service";

export interface IHostedCompetitionAddOption {
  teamId: number;
  hostedCompetitionData: IHostedCompetitionDTO;
}

interface IHostedCompetitionAddState {
  hostedCompetitionAddResponseStatus: StatusEnum;
}

const initialState: IHostedCompetitionAddState = {
  hostedCompetitionAddResponseStatus: StatusEnum.Idle,
};

export const hostedCompetitionAdd = createAsyncThunk(
  "manage/hostedCompetitionAdd",
  async (options: IHostedCompetitionAddOption, thunkAPI) => {
    try {
      const hostedCompetitionAddResponse = await manageFootballTeamService.addHostedCompetition(
        options.teamId,
        options.hostedCompetitionData
      );
      return hostedCompetitionAddResponse;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const manageHostedCompetitionAddSlice = createSlice({
  name: "hostedCompetitionAdd",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(hostedCompetitionAdd.pending, (state) => {
        state.hostedCompetitionAddResponseStatus = StatusEnum.Loading;
      })
      .addCase(hostedCompetitionAdd.fulfilled, (state) => {
        state.hostedCompetitionAddResponseStatus = StatusEnum.Succeeded;
      })
      .addCase(hostedCompetitionAdd.rejected, (state) => {
        state.hostedCompetitionAddResponseStatus = StatusEnum.Failed;
      });
  },
});

export default manageHostedCompetitionAddSlice.reducer;
